import React from 'react';
import { REASON_META, primaryReason } from '../utils/shiftReasons';

// Small "why this shift can't go live" chip for ADMIN surfaces (dashboard, job board, calendars,
// EVV, pre-approval). Renders nothing when there's no blocking reason (or the shift is cancelled).
// Pass a shift row that carries pending_reason / pending_detail (and optionally the board's inline
// flags). Do NOT use on worker/family-facing screens — these reasons are internal.
export default function ReasonBadge({ shift, className = '' }) {
  const code = primaryReason(shift);
  if (!code) return null;
  const m = REASON_META[code];
  if (!m) return null;
  return (
    <span
      className={`px-1.5 py-0.5 rounded-full text-[10px] font-semibold leading-none ${m.cls} ${className}`}
      title={shift?.pending_detail || m.tip}
    >
      {m.label}
    </span>
  );
}
